import React from 'react';
import FormField from '../FormField';
import SectionHeader from '../SectionHeader';

const StaffOverview = ({ formData, handleChange, bdeEmployees, isVisible, toggleSection }) => {
  return (
    <div className="form-section">
      <SectionHeader 
        title="Staff & Student Overview" 
        isVisible={isVisible} 
        onClick={toggleSection} 
      />
      
      {isVisible && (
        <div className="section-content">
          <FormField
            label="Admin Name"
            type="select"
            name="adminName"
            value={formData.adminName}
            onChange={handleChange}
            options={bdeEmployees.map(emp => ({
              value: emp.emp_name,
              label: emp.emp_name
            }))}
          />
          
          <FormField
            label="Source"
            name="source"
            value="Direct"
            onChange={handleChange}
            readOnly={true}
          />
          
          <FormField
            label="Student Requirement"
            type="textarea"
            name="studentRequirement"
            value={formData.studentRequirement}
            onChange={handleChange}
          />
        </div>
      )}
    </div>
  );
};

export default StaffOverview;